module.exports = __webpack_public_path__ + "img/tarj1.13b8ba6a.svg";